import React, { useContext } from "react";
import LanguageContext from "../../components/Language/LanguageContext";
import { Link } from "react-router-dom";
import SupportandHelp from "../FAQ/SupportandHelp";

const Footer = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  const handleSmoothScroll = (
    event: React.MouseEvent<HTMLAnchorElement>,
    sectionId: string
  ) => {
    event.preventDefault();
    const section = document.querySelector(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <div
        className="grid grid-nogutter surface-section px-4  md:px-6 lg:px-8  "
        id="contact"
        style={{ borderTop: "1px solidrgb(196, 197, 199)" }}
      >
        <div
          className="col-12 lg:col-6 p-4"
          style={{ borderRight: "1px solidrgb(196, 197, 199)" }}
        >
          <img
            src="/images/Footer/logo-enerren.png"
            className="w-18rem mx-auto lg:mx-0"
            alt="Peak logo"
          />
          <span className="text-900 block mt-4 mr-3">
            PT.Enerren Technologies <br /> Graha Inti Fauzi Lt 8 Jalan Buncit
            Raya No. 22, <br />
            Jakarta Selatan 12510, <br />
            <span className="solid">info@smartsafetee.com</span>
          </span>
          <span className="text-500 block mt-4">
            © {new Date().getFullYear()}, SmartSafetee. Powered by Enerren
            Technologies.
          </span>
        </div>
        <div className="col-12 md:col-2 lg:col-3 mt-4 lg:mt-0 lg:pl-4 flex flex-column p-4">
          <span className="text-900 text-xl font-medium block">
            {messages.SitusFooter}
          </span>
          <ul className="list-none p-0">
            <li>
              <a
                tabIndex={0}
                className="transition-duration-150 cursor-pointer mt-3 block footer"
                href="#home"
                onClick={(e) => handleSmoothScroll(e, "#home")}
                style={{ textDecoration: "none" }}
              >
                {messages.home}
              </a>
            </li>
            <li>
              <a
                tabIndex={0}
                className="transition-duration-150 cursor-pointer mt-3 block footer"
                href="#product"
                onClick={(e) => handleSmoothScroll(e, "#product")}
                style={{ textDecoration: "none" }}
              >
                {" "}
                {messages.products}
              </a>
            </li>
            <li>
              <a
                href="#features"
                onClick={(e) => handleSmoothScroll(e, "#features")}
                style={{ textDecoration: "none" }}
                tabIndex={0}
                className="transition-duration-150 cursor-pointer mt-3 block footer"
              >
                {messages.ApplicationPurpose}
              </a>
            </li>
            <li>
              <a
                href="#benefit"
                onClick={(e) => handleSmoothScroll(e, "#benefit")}
                style={{ textDecoration: "none" }}
                tabIndex={0}
                className="transition-duration-150 cursor-pointer mt-3 block footer"
              >
                {messages.Featured}
              </a>
            </li>
            <li>
              <a
                href="#pricing"
                onClick={(e) => handleSmoothScroll(e, "#pricing")}
                style={{ textDecoration: "none" }}
                tabIndex={0}
                className="transition-duration-150 cursor-pointer mt-3 block footer"
              >
                {messages.pricing}
              </a>
            </li>
            {/* <li>
              <a
                tabindex="0"
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">
                Privacy and Policy
              </a>
            </li> */}
          </ul>
        </div>
        <div className="col-12 md:col-2 lg:col-3 mt-4 lg:mt-0 lg:pl-4 flex flex-column p-4">
          <span className="text-900 text-xl font-medium block">Membership</span>
          <ul className="list-none p-0">
            <li>
              <Link
                tabIndex={0}
                to='/support'
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block"
                style={{textDecoration:'none'}}
              >
                Support
              </Link>
            </li>
            <li>
              <Link
                tabIndex={0}
                to='/privacy'
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block"
                style={{textDecoration:'none'}}
              >
                Privacy Policy
              </Link>
            </li>
            <li>
              <a
                tabIndex={0}
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block"
              >
                {/* Login */}
              </a>
            </li>
            <li>
              <a
                tabIndex={0}
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block"
              >
                {/* Sign Up For Free */}
              </a>
            </li>
            {/* <li>
              <a
                tabindex="0"
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">
                User Account
              </a>
            </li>
            <li>
              <a
                tabindex="0"
                className="text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 block">
                Reset Password
              </a>
            </li> */}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Footer;
